import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import qs from 'qs';

import {
    changeCalendarPeriod,
    changeCalendarTaskView
} from 'actions/calendarActions';
import { getUser } from 'actions/asyncActions';
import { DATE_FORMATS } from 'constants/dateFormats';
import { periodConfig } from 'constants/calendar';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import CalendarList from './CalendarList';
import CalendarControls from './HeadPanel/CalendarControls';

const stateToProps = state => ({
    user: getUser.selectData(state),
    period: state.calendar.period,
    showCompletedTasks: state.calendar.showCompletedTasks,
});

const dispatchToProps = {
    changeCalendarPeriod,
    changeCalendarTaskView
};

const getDate = ({ location }) => {
    const { date } = qs.parse(location.search, { ignoreQueryPrefix: true }) || {};
    return date ? moment(date, DATE_FORMATS.parse) : moment();
};

@connect(stateToProps, dispatchToProps)
@withRouteOptions
export default class CalendarView extends Component {
    static routeOptions = {
        title: 'menu.calendar'
    }

    state = {
        date: getDate(this.props),
        planner: true,
        education: true,
        filters: []
    }

    onDateSelect = (date) => {
        this.setState({
            date
        });
    };

    onPeriodChange = (e) => {
        this.props.changeCalendarPeriod({
            period: e.target.value
        });
    };

    onPreviousPeriodClick = () => {
        this.changePeriod(false);
    };

    onNextPeriodClick = () => {
        this.changePeriod(true);
    };

    onFiltersChange = (values) => {
        this.setState({
            filters: values,
            planner: false
        });
    };

    onPlannerChange = () => {
        this.setState(({ planner }) => ({
            planner: !planner
        }));
    };

    onEducationChange = () => {
        this.setState(({ education }) => ({
            education: !education
        }));
    }

    onShowCompletedTasksToggle = () => {
        this.props.changeCalendarTaskView({
            showCompletedTasks: !this.props.showCompletedTasks
        });
    };

    changePeriod = (next) => {
        this.setState(({ date }) => {
            const days = periodConfig[this.props.period].days;

            const { location: { pathname }, history } = this.props;
            const newDate = date.clone().add(next ? days : -days, 'days');

            history.replace(`${pathname}?date=${newDate.format(DATE_FORMATS.parse)}`);

            return { date: newDate };
        });
    };

    render() {
        const { match: { params: { id: userId } }, user } = this.props;
        const filterHandlers = {
            onPeriodChange: this.onPeriodChange,
            onPreviousPeriodClick: this.onPreviousPeriodClick,
            onNextPeriodClick: this.onNextPeriodClick,
            onFiltersChange: this.onFiltersChange,
            onPlannerChange: this.onPlannerChange,
            onDateSelect: this.onDateSelect,
            onEducationChange: this.onEducationChange
        };

        return user && (
            <div className="calendar-view">
                <CalendarControls userId={userId || user.id} user={user} date={this.state.date} />
                <CalendarList
                    userId={userId || user.id}
                    user={user}
                    planner={this.state.planner}
                    education={this.state.education}
                    filters={this.state.filters}
                    date={this.state.date}
                    period={this.props.period}
                    showCompletedTasks={this.props.showCompletedTasks}
                    onShowCompletedTasksToggle={this.onShowCompletedTasksToggle}
                    filterHandlers={filterHandlers}
                />
            </div>
        );
    }
}
